import React from "react";
import { withNavBars } from "../../HOCs";
import { ResidentTableView } from "./residentTableView";

class ResidentTableViewParent extends React.Component {
    render() {
        return <ResidentTableView />
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(ResidentTableViewParent, props);
